export default __webpack_public_path__ + "static/media/SampleCattlePromotion.9497ac44.svg";